import { render, staticRenderFns } from "./ReportIssueModal.vue?vue&type=template&id=482e5e85&"
import script from "./ReportIssueModal.vue?vue&type=script&lang=ts&"
export * from "./ReportIssueModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports